<template>
  <div class="points">
    <loading :active.sync="isLoading" color="#4CAF50" :width=100 :height=100 :opacity=.7></loading>
    <div v-if="hasPoints && !routeCompleted" class="start">
      <div class="container">
        <div class="row">
          <div class="start__row">
            <div class="col-sm-12 d-flex justify-content-between align-items-baseline">
              <div class="start__route">Маршрут № {{points.summary.routeId}}</div>
            </div>
            <div class="col-sm-12 d-flex justify-content-between align-items-baseline">
              <div class="start__destination">
                Отчитано {{points.summary.numCompletedPoints}} из {{points.summary.totalPoints}} точек
              </div>
              <div v-if="points.summary.started" class="start__time">работаем</div>
            </div>
          </div>
        </div>
      </div>
      <div class="start__progress">
        <div class="start__percent" :style="'width:' + progress">{{progress}}</div>
      </div>
      <div class="start__address-wrap">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="start__address">
                {{points.summary.address}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ul class="start__route-list" v-for="p in points.points" :key="p.pointId">
        <Point :routeSummary="points.summary" :point="p" :problems="problems" @changed="fetchPoints"
          @startUpdate="setLoading(true)" @endUpdate="setLoading(false)" />
      </ul>
    </div>
    <div v-if="hasPoints && routeCompleted" class="first-last-step first-last-step--last">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="first-last-step__name">{{points.agent.fullname}}</div>
            <div class="first-last-step__succes">Ты большой молодец!</div>
          </div>
          <div class="col-md-12">
            <div class="first-step__card card clearfix">
              <div class="card__route">Маршрут № {{points.summary.routeId}} пройден</div>
              <ul class="card__res">
                <li>Обратись к старшим, если нужна еще работенка. :-)</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $backend from '../backend'
import Loading from 'vue-loading-overlay'
import Point from '@/components/Point.vue'

export default {
  name: 'points',
  data () {
    return {
      isLoading: false,
      points: null,
      problems: []
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    hasPoints () {
      return this.points !== null && this.points.summary !== null
    },
    progress () {
      return `${this.points.summary.progress}%`
    },
    routeCompleted () {
      return this.hasPoints && this.points.summary.progress === 100
    }
  },
  components: {
    Loading,
    Point
  },
  methods: {
    fetchData () {
      this.fetchPoints()
        .then(this.fetchProblems)
    },
    fetchPoints () {
      this.setLoading(true)
      let routeId = this.$route.params.routeId
      return $backend.fetchData(`points/${routeId}`, { filter: true })
        .then(data => {
          this.points = data
          return data
        })
        .then(data => {
          if (!data.summary) {
            throw Error('Нет доступных точек. Обратитесь к старшему.')
          }
          if (data.summary.started === false) {
            this.$router.push({ name: 'firstStep' })
          }
        })
        .catch(error => {
          this.$swal({ type: 'error', text: error.message })
        })
        .finally(() => {
          this.setLoading(false)
        })
    },
    fetchProblems () {
      this.setLoading(true)
      return $backend.fetchData('points/problems')
        .then(data => {
          this.problems = data
        })
        .finally(() => {
          this.setLoading(false)
        })
    },
    setLoading (status) {
      this.isLoading = status
    }
  }
}
</script>
